import React, { useRef } from "react"
import { useClickOutside } from "../../../hooks"
import { motion, AnimatePresence } from "framer-motion"
import { cn } from "../../../../lib"
import { CALENDAR_FIX_MODE } from "../../../utils/variables/calendar"
import { Calendar, CalendarBottomHead } from "../../Calendar"

const CalendarModal = ({
  showModal,
  onClose,
  onDatesChange,
  className,
  isDeparture,
  dates = {},
  mode = CALENDAR_FIX_MODE,
  availableDepart,
  availableRetur,
  departPriceData,
  returPriceData,
  onCalendarMonthChange,
  currencySymbol,
}) => {
  const modalRef = useRef(null)
  useClickOutside(modalRef, onClose)

  const from = dates.depart ?? []
  const to = dates.return ?? []

  return (
    <AnimatePresence>
      {showModal && (
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: -10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: -10 }}
          transition={{ duration: 0.18, ease: "easeOut" }}
          className={cn(
            "fixed bottom-0 left-0 md:left-auto w-full md:absolute md:top-[60px] z-50 md:w-max md:min-w-[630px] h-[425px]",
            className
          )}
        >
          <div
            ref={modalRef}
            className="bg-white rounded-lg overflow-hidden w-full relative shadow-xl"
          >
            <div>
              <CalendarBottomHead
                from={from}
                to={to}
                isDeparture={isDeparture}
                roundTrip={to.length > 0}
              />
            </div>
            <div className="px-6 py-2 bg-white">
              <Calendar
                datesState={{ from, to }}
                isDeparture={isDeparture}
                from={from}
                to={to}
                mode={mode}
                onDatesChange={({ from: newFrom, to: newTo }) => {
                  onDatesChange?.({ from: newFrom, to: newTo })
                }}
                availableDepart={availableDepart}
                availableRetur={availableRetur}
                departPriceData={departPriceData}
                returPriceData={returPriceData}
                onCalendarMonthChange={onCalendarMonthChange}
                currencySymbol={currencySymbol}
              />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default CalendarModal
